export default __webpack_public_path__ + "static/todayshopbold-29df52ded1ad48c0f721664978088d3a.woff";